import {
  autoUpdate,
  flip,
  offset,
  size,
  useFloating,
} from '@floating-ui/react-dom';

/** Keeps the options panel aligned with the combobox field. */
export function useComboboxPositioning() {
  return useFloating({
    middleware: [
      flip(),
      size({
        apply({ rects, elements }) {
          Object.assign(elements.floating.style, {
            width: `${rects.reference.width}px`,
          });
        },
      }),
      offset(({ placement }) => {
        // Options have an 8px margin, so top placement needs a larger offset.
        if (placement === 'top') return 16;
        return 0;
      }),
    ],
    whileElementsMounted: autoUpdate,
  });
}
